import {
  Breadcrumb,
  Button,
  Card,
  DatePicker,
  Form,
  Input,
  Modal,
  Select,
} from "antd";
import React, { useState, useCallback, useEffect } from "react";
import { useNavigate } from "react-router";
import AccountService from "../../../../services/accounts.service";
import { NumericFormat } from "react-number-format";
import {
  allowOnlyAlphaNumericsWithSpace,
  allowOnlyAlphabets,
  allowOnlyNumbers,
  amountFormat,
} from "../../../../services/common.service";
import dayjs, { Dayjs } from "dayjs";
import Loader from "../../../../components/loader";
import personalLoanIcon from "../../../../assests/images/Personal Loan.svg";
import goldLoadIcon from "../../../../assests/images/Gold Loan.svg";
import vehicleLoanIcon from "../../../../assests/images/Vehicle Loan.svg";
import housingLoanIcon from "../../../../assests/images/Housing Loan.svg";
import educationLoanIcon from "../../../../assests/images/Education loan.svg";
import termLoanIcon from "../../../../assests/images/Term Loan.svg";
import CommonOtp from "../../../../components/otp";
import successIcon from "../../../../assests/images/thumb_up.gif";
import moment from "moment";
import { useTranslation } from "react-i18next";
import { ReactComponent as TitleIcon } from "../../../../assests/images/accountBread.svg";
import { CONFIG } from "../../../../environment";
import AccountCard from "../../../../components/account-card";
import { ReactComponent as TickIcon } from "../../../../assests/images/tickIcon.svg";
import AccountSelectedCard from "../../../../components/account-selected-card";
import { ReactComponent as HomeIcon } from "../../../../assests/images/home-line.svg";

export default function ApplyNewLoan() {
  const navigate = useNavigate();
  const [stage, setStage] = useState(2);
  const [form] = Form.useForm();
  const [loader, setLoader] = useState(false);
  const [cityList, setCityList] = useState([]);
  const [stateList, setStateList] = useState([]);
  const [pageLoader, setPageLoader] = useState(false);
  const [selectedLoanType, setSelectedLoanType] = useState("");
  const [collateral, setCollateral] = useState("No");
  const [formDetails, setFormDetails] = useState({});
  const [reqValues, setReqValues] = useState({});
  const [message, setMessage] = useState("");
  const [successVisible, setSuccessVisible] = useState(false);
  const [otp, setOtp] = useState("");
  const [metaData, setMetaData] = useState({
    loanTypes: [],
    incomeRange: [],
    purpose: [],
    "Source of Income": [],
  });
  const { t } = useTranslation();
  const [selectedDate, setSelectedDate] = useState(null);
  const [selectedProfession, setSelectedProfession] = useState("");
  const defaultPickerValue = selectedDate
    ? selectedDate
    : dayjs().subtract(18, "years");

  const handleDateChange = (date) => {
    setSelectedDate(date);
  };

  useEffect(() => {
    getLoanRequestValues();
    getCityDetails();
    getProducts();
  }, []);

  const getLoanRequestValues = useCallback(async () => {
    try {
      setPageLoader(true);
      const response = await AccountService.getLoanRequestValues({});
      if (response.status === 200) {
        setPageLoader(false);
        setMetaData(response.data.data["values"]);
      }
    } catch (error) {
      setPageLoader(false);
    }
  }, []);

  const getCityDetails = useCallback(async () => {
    try {
      const response = await AccountService.getCityDetails();
      if (response.status === 200) {
        setCityList(response.data["data"]);
      }
    } catch (error) {}
  }, []);

  const getProducts = useCallback(async () => {
    try {
      const response = await AccountService.getProducts();
      if (response.status === 200) {
        setStateList(response.data["stateCodesList"] || []);
      }
    } catch (error) {}
  }, []);

  const onVerify = useCallback((values) => {
    try {
      setFormDetails(values);
      setStage(3);
    } catch (error) {}
  }, []);

  const loanRequestVerify = useCallback(async () => {
    try {
      const reqParms = {
        mobileNumber: formDetails?.mobileNumber || "",
        name: formDetails?.name || "",
        emailId: formDetails?.emailId || "",
        state: formDetails?.state || "",
        city: formDetails?.city || "",
        profession:
          formDetails?.profession === "Other"
            ? formDetails?.sourceofIncome
            : formDetails?.profession,
        creditFacilityAvailed:
          formDetails?.creditFacilityAvailed === "Yes" ? true : false,
        interestRate: formDetails?.interestRate || "",
        tenure: formDetails?.tenure || "",
        securityOffered: formDetails?.securityOffered || "",
        qtyGramsGold:
          selectedLoanType === "Gold Loan"
            ? parseInt(formDetails.qtyGramsGold.replaceAll(/,/g, ""))
            : "",
        vehicleRequired: formDetails?.vehicleRequired || "",
        propertyLocation: formDetails?.propertyLocation || "",
        propertyMarketValue:
          selectedLoanType === "Housing Loan"
            ? parseInt(formDetails.propertyMarketValue.replaceAll(/,/g, ""))
            : "",
        location: formDetails?.location || "",
        collateralImmovableProperty:
          formDetails?.collateralImmovableProperty === "Yes" ? true : false,
        propertyValue:
          ["Education Loan", "Term Loan"].indexOf(selectedLoanType) >
            -1 && collateral === "Yes"
            ? parseInt(formDetails.propertyValue.replaceAll(/,/g, ""))
            : "",
        purposeOfLoan: formDetails?.purposeOfLoan || "",
        loanType: selectedLoanType,
        annualIncome: parseInt(formDetails.annualIncome.replaceAll(/,/g, "")),
        monthlyIncome: parseInt(formDetails.monthlyIncome.replaceAll(/,/g, "")),
        loanAmount: parseInt(formDetails.loanAmount.replaceAll(/,/g, "")),
        dob: dayjs(formDetails.dob).format("YYYY-MM-DD"),
      };
      setLoader(true);
      setReqValues(reqParms);
      const response = await AccountService.loanRequestVerify(reqParms);
      if (response.status === 200) {
        setLoader(false);
        setStage(4);
      }
    } catch (error) {
      setLoader(false);
    }
  }, [formDetails, selectedLoanType, collateral, selectedProfession]);

  const loanRequestConfirm = useCallback(async (reqParams) => {
    try {
      setLoader(true);
      const response = await AccountService.loanRequestConfirm(reqParams);
      if (response.status === 200) {
        setStage(5);
        setLoader(false);
        setMessage(response.data["message"]);
        setSuccessVisible(true);
      }
    } catch (error) {
      setLoader(false);
    }
  }, []);

  function renderSwitch() {
    switch (stage) {
      case 1:
        return renderLoanTypes();
      case 2:
        return renderForm();

      case 3:
        return renderConfirm();

      case 4:
        return (
          <CommonOtp
            otp={otp}
            setOtp={setOtp}
            type="TRANSACTION"
            onConfirm={(values) =>
              loanRequestConfirm({
                ...reqValues,
                ...values,
              })
            }
            handleResendOtp={() => handleResendOtp()}
            cancelTransaction={() => {
              navigate("/accounts", { state: "LA" });
            }}
          />
        );

      default:
        return renderForm();
    }
  }

  const handleResendOtp = useCallback(
    async (values) => {
      try {
        const requestParams = {
          ...formDetails,
        };
        const response = await AccountService.loanRequestVerify(requestParams);
        if (response.status === 200) {
          setLoader(false);
        }
      } catch (error) {}
    },
    [formDetails]
  );

  function renderLoanTypes() {
    return (
      <>
        <p className="mb-3">
          {t("pages.my_accounts.loans.select_loan_type", {
            defaultValue: "Please select Finance type, before you proceed",
          })}
        </p>
        {pageLoader && <Loader />}
        <div className="row">
          {metaData.loanTypes.map((option, idx) => (
            <div
              key={idx}
              className="col-xs-12 col-sm-12 col-md-12 col-lg-4 col-xl-4"
            >
              <Card
                onClick={() => {
                  setSelectedLoanType(option);
                  if (selectedLoanType === "Gold Loan") {
                    form.setFieldsValue({
                      tenure: 12,
                    });
                  }
                  setStage(2);
                }}
                className={
                  selectedLoanType === option
                    ? "mb-4 loan-types loan-selected application-card"
                    : "mb-4 loan-types application-card"
                }
                style={{ cursor: "pointer" }}
              >
                {option === "Personal Loan" ? (
                  <img
                    className="d-block mb-3"
                    style={{ margin: "0 auto" }}
                    src={personalLoanIcon}
                    alt="personal"
                  />
                ) : option === "Gold Loan" ? (
                  <img
                    className="d-block mb-3"
                    style={{ margin: "0 auto" }}
                    src={goldLoadIcon}
                    alt="personal"
                  />
                ) : option === "Vehicle Loan" ? (
                  <img
                    className="d-block mb-3"
                    style={{ margin: "0 auto" }}
                    src={vehicleLoanIcon}
                    alt="personal"
                  />
                ) : option === "Housing Loan" ? (
                  <img
                    className="d-block mb-3"
                    style={{ margin: "0 auto" }}
                    src={housingLoanIcon}
                    alt="personal"
                  />
                ) : option === "Education Loan" ? (
                  <img
                    className="d-block mb-3"
                    style={{ margin: "0 auto" }}
                    src={educationLoanIcon}
                    alt="personal"
                  />
                ) : option === "Term Loan" ? (
                  <img
                    className="d-block mb-3"
                    style={{ margin: "0 auto" }}
                    src={termLoanIcon}
                    alt="personal"
                  />
                ) : (
                  <img
                    className="d-block mb-3"
                    style={{ margin: "0 auto" }}
                    src={personalLoanIcon}
                    alt="personal"
                  />
                )}

                <h6 style={{ textAlign: "center", margin: 0 }}>{option}</h6>
              </Card>
            </div>
          ))}
        </div>
      </>
    );
  }

  function renderForm() {
    return (
      <>
        <p className="mb-3">
          {t("common.proceed_fill_txt", {
            defaultValue: "Please fill required details, before you proceed",
          })}
        </p>
        <Form onFinish={onVerify} layout="vertical" form={form}>
          <div className="row">
            <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
              <Form.Item
                label={t("pages.my_accounts.loans.facility_type", {
                  defaultValue: "Investment Type",
                })}
                name={"facilityType"}
                rules={[
                  {
                    required: true,
                    message: t("pages.my_accounts.loans.facility_type_req", {
                      defaultValue: "Investment Type is required",
                    }),
                  },
                ]}
              >
                <Select
                  showSearch
                  optionFilterProp="children"
                  placeholder={t("pages.my_accounts.loans.facility_type", {
                    defaultValue: "Investment Type",
                  })}
                  size="large"
                  onChange={(e) => setSelectedLoanType(e)}
                >
                  {metaData.loanTypes.map((option, idx) => (
                    <Select.Option key={idx} value={option}>
                      {option}
                    </Select.Option>
                  ))}
                </Select>
              </Form.Item>
            </div>

            <div className="col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6">
              <Form.Item
                label={t("common.mobile_number", {
                  defaultValue: "Mobile Number",
                })}
                name={"mobileNumber"}
                rules={[
                  {
                    required: true,
                    message: t("errorMesssages.mobile_no_requir", {
                      defaultValue: "Mobile Number is required",
                    }),
                  },
                ]}
              >
                <Input
                  addonBefore={CONFIG.DEFAULT_MOBILE_PREFIX}
                  placeholder={t("common.mobile_number", {
                    defaultValue: "Mobile Number",
                  })}
                  size="large"
                />
              </Form.Item>
            </div>

            <div className="col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6">
              <Form.Item
                label={t("pages.my_accounts.casa.name", {
                  defaultValue: "Name",
                })}
                name={"name"}
                rules={[
                  {
                    required: true,
                    message: t("pages.my_accounts.loans.name_req_txt", {
                      defaultValue: "Name is required",
                    }),
                  },
                ]}
              >
                <Input
                  placeholder={t("pages.my_accounts.casa.name", {
                    defaultValue: "Name",
                  })}
                  size="large"
                />
              </Form.Item>
            </div>

            <div className="col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6">
              <Form.Item
                label={t("pages.forgotPassword.date_of_birth", {
                  defaultValue: "Date of Birth",
                })}
                name={"dob"}
                rules={[
                  {
                    required: true,
                    message: t("errorMesssages.date_of_birth_required", {
                      defaultValue: "Date Of Birth is required",
                    }),
                  },
                ]}
              >
                <DatePicker
                  style={{ width: "100%" }}
                  value={selectedDate}
                  onChange={handleDateChange}
                  defaultPickerValue={defaultPickerValue}
                  disabledDate={(current) =>
                    current && current.isAfter(moment().subtract(18, "years"))
                  }
                  placeholder="DD-MM-YYYY"
                  format={"DD-MM-YYYY"}
                  showToday={false}
                  size="large"
                  // inputReadOnly={true}
                />
              </Form.Item>
            </div>

            <div className="col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6">
              <Form.Item
                label={t("common.email_id", {
                  defaultValue: "Email Id",
                })}
                name={"emailId"}
                rules={[
                  {
                    required: true,
                    message: t("pages.profile.email_req_txt", {
                      defaultValue: "Email Id is required",
                    }),
                  },
                  {
                    type: "email",
                    message: t("pages.profile.invalid_email_txt", {
                      defaultValue: "Invalid Email Id",
                    }),
                  },
                ]}
              >
                <Input
                  maxLength={30}
                  placeholder={t("common.email_id", {
                    defaultValue: "Email Id",
                  })}
                  size="large"
                />
              </Form.Item>
            </div>

            <div className="col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6">
              <Form.Item
                label={t("pages.my_accounts.loans.state", {
                  defaultValue: "State",
                })}
                name={"state"}
                rules={[
                  {
                    required: true,
                    message: t("pages.my_accounts.loans.state_req_txt", {
                      defaultValue: "State is required",
                    }),
                  },
                ]}
              >
                <Select
                  showSearch
                  optionFilterProp="children"
                  placeholder={t("pages.my_accounts.loans.state", {
                    defaultValue: "State",
                  })}
                  size="large"
                >
                  {stateList.map((option, idx) => (
                    <Select.Option key={idx} value={option.label}>
                      {option.value}
                    </Select.Option>
                  ))}
                </Select>
              </Form.Item>
            </div>

            <div className="col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6">
              <Form.Item
                label={t("pages.my_accounts.loans.city", {
                  defaultValue: "City",
                })}
                name={"city"}
                rules={[
                  {
                    required: true,
                    message: t("pages.my_accounts.loans.city_req_txt", {
                      defaultValue: "City is required",
                    }),
                  },
                ]}
              >
                <Select
                  showSearch
                  optionFilterProp="children"
                  placeholder={t("pages.my_accounts.loans.city", {
                    defaultValue: "City",
                  })}
                  size="large"
                >
                  {cityList.map((option, idx) => (
                    <Select.Option key={idx} value={option.cityCodeLabel}>
                      {option.cityCodeValue}
                    </Select.Option>
                  ))}
                </Select>
              </Form.Item>
            </div>

            {selectedLoanType === "Term Loan" && (
              <div className="col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6">
                <Form.Item
                  label={t("pages.my_accounts.loans.purpose_of_loan", {
                    defaultValue: "Purpose of Finance",
                  })}
                  name={"purposeOfLoan"}
                  rules={[
                    {
                      required: true,
                      message: t(
                        "pages.my_accounts.loans.purpose_of_loan_req_txt",
                        {
                          defaultValue: "Purpose of Finance is required",
                        }
                      ),
                    },
                  ]}
                >
                  <Input
                    onKeyPress={(e) => allowOnlyAlphaNumericsWithSpace(e)}
                    maxLength={30}
                    placeholder={t("pages.my_accounts.loans.purpose_of_loan", {
                      defaultValue: "Purpose of Finance",
                    })}
                    size="large"
                  />
                </Form.Item>
              </div>
            )}

            <div className="col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6">
              <Form.Item
                label={t("pages.my_accounts.loans.profession", {
                  defaultValue: "Profession",
                })}
                name={"profession"}
                rules={[
                  {
                    required: true,
                    message: t("pages.my_accounts.loans.profession_req_txt", {
                      defaultValue: "Profession is required",
                    }),
                  },
                ]}
              >
                <Select
                  showSearch
                  optionFilterProp="children"
                  placeholder={t("pages.my_accounts.loans.profession", {
                    defaultValue: "Profession",
                  })}
                  size="large"
                  onChange={(e) => setSelectedProfession(e)}
                >
                  {metaData["Source of Income"].map((option, idx) => (
                    <Select.Option key={idx} value={option}>
                      {option}
                    </Select.Option>
                  ))}
                </Select>
              </Form.Item>
            </div>
            {selectedProfession === "Other" && (
              <div className="col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6">
                <Form.Item
                  label={"Enter Source Of Income"}
                  name={"sourceofIncome"}
                  rules={[
                    {
                      required: true,
                      message: "Source Of Income is required",
                    },
                  ]}
                >
                  <Input
                    maxLength={30}
                    placeholder={"Source Of Income"}
                    onKeyPress={(e) => allowOnlyAlphaNumericsWithSpace(e)}
                    size="large"
                  />
                </Form.Item>
              </div>
            )}

            {selectedLoanType === "Vehicle Loan" && (
              <div className="col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6">
                <Form.Item
                  label={t("pages.my_accounts.loans.type_of_vehicle", {
                    defaultValue: "Type of Vehicle",
                  })}
                  name={"vehicleRequired"}
                  rules={[
                    {
                      required: true,
                      message: t(
                        "pages.my_accounts.loans.type_of_vehicle_req_txt",
                        {
                          defaultValue: "Type of vehicle is required",
                        }
                      ),
                    },
                  ]}
                >
                  <Select
                    showSearch
                    optionFilterProp="children"
                    placeholder={t("pages.my_accounts.loans.type_of_vehicle", {
                      defaultValue: "Type of Vehicle",
                    })}
                    size="large"
                  >
                    {["Two wheeler", "Four wheeler"].map((option, idx) => (
                      <Select.Option key={idx} value={option}>
                        {option}
                      </Select.Option>
                    ))}
                  </Select>
                </Form.Item>
              </div>
            )}

            {["Education Loan", "Term Loan"].indexOf(selectedLoanType) >
              -1 && (
              <div className="col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6">
                <Form.Item
                  label={t("pages.my_accounts.loans.location", {
                    defaultValue: "Location",
                  })}
                  name={"location"}
                  rules={[
                    {
                      required: true,
                      message: t("pages.my_accounts.loans.location_req_txt", {
                        defaultValue: "Location is required",
                      }),
                    },
                  ]}
                >
                  <Select
                    showSearch
                    optionFilterProp="children"
                    placeholder={t("pages.my_accounts.loans.location", {
                      defaultValue: "Location",
                    })}
                    size="large"
                  >
                    {["India", "Abroad "].map((option, idx) => (
                      <Select.Option key={idx} value={option}>
                        {option}
                      </Select.Option>
                    ))}
                  </Select>
                </Form.Item>
              </div>
            )}

            {["Education Loan", "Term Loan"].indexOf(selectedLoanType) >
              -1 && (
              <div className="col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6">
                <Form.Item
                  label={t("pages.my_accounts.loans.collateral", {
                    defaultValue: "Collateral",
                  })}
                  name={"collateralImmovableProperty"}
                  rules={[
                    {
                      required: true,
                      message: t("pages.my_accounts.loans.collateral_req_txt", {
                        defaultValue: "Collateral  is required",
                      }),
                    },
                  ]}
                >
                  <Select
                    showSearch
                    optionFilterProp="children"
                    placeholder={t("pages.my_accounts.loans.collateral", {
                      defaultValue: "Collateral",
                    })}
                    onChange={setCollateral}
                    size="large"
                  >
                    {["Yes", "No"].map((option, idx) => (
                      <Select.Option key={idx} value={option}>
                        {option}
                      </Select.Option>
                    ))}
                  </Select>
                </Form.Item>
              </div>
            )}

            {["Education Loan", "Term Loan"].indexOf(selectedLoanType) >
              -1 &&
              collateral === "Yes" && (
                <div className="col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6">
                  <Form.Item
                    label={t("pages.my_accounts.loans.property_value", {
                      defaultValue: "Property Value",
                    })}
                    name={"propertyValue"}
                    rules={[
                      {
                        required: true,
                        message: t("pages.my_accounts.loans.property_value", {
                          defaultValue: "Property value  is required",
                        }),
                      },
                    ]}
                  >
                    <NumericFormat
                      type="tel"
                      maxLength={12}
                      placeholder={t("pages.my_accounts.loans.property_value", {
                        defaultValue: "Property Value",
                      })}
                      allowNegative={false}
                      customInput={Input}
                      thousandSeparator={true}
                      fixedDecimalScale={false}
                      onKeyPress={(e) => allowOnlyNumbers(e)}
                      size="large"
                    />
                  </Form.Item>
                </div>
              )}

            {selectedLoanType === "Gold Loan" && (
              <div className="col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6">
                <Form.Item
                  label={t("pages.my_accounts.loans.Qty_grms", {
                    defaultValue:
                      "Qty/grams of gold you wish to mortgage pledge",
                  })}
                  name={"qtyGramsGold"}
                  rules={[
                    {
                      required: true,
                      message: t("pages.my_accounts.loans.Qty_grms_req_txt", {
                        defaultValue: "Qty/grams is required",
                      }),
                    },
                  ]}
                >
                  <NumericFormat
                    type="tel"
                    maxLength={12}
                    placeholder={t("pages.my_accounts.loans.Qty_grms", {
                      defaultValue:
                        "Qty/grams of gold you wish to mortgage pledge",
                    })}
                    allowNegative={false}
                    customInput={Input}
                    thousandSeparator={true}
                    fixedDecimalScale={false}
                    onKeyPress={(e) => allowOnlyNumbers(e)}
                    size="large"
                  />
                </Form.Item>
              </div>
            )}

            <div className="col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6">
              <Form.Item
                label={t("pages.my_accounts.loans.credit_facility_ifAny", {
                  defaultValue: "Any other credit Loan availed with us",
                })}
                name={"creditFacilityAvailed"}
                rules={[
                  {
                    required: true,
                    message: t(
                      "pages.my_accounts.loans.credit_facility_req_txt",
                      {
                        defaultValue: "credit facility is required",
                      }
                    ),
                  },
                ]}
              >
                <Select
                  showSearch
                  optionFilterProp="children"
                  placeholder={t(
                    "pages.my_accounts.loans.credit_facility_ifAny",
                    {
                      defaultValue: "Any other credit Loan availed with us",
                    }
                  )}
                  size="large"
                >
                  {["Yes", "No"].map((option, idx) => (
                    <Select.Option key={idx} value={option}>
                      {option}
                    </Select.Option>
                  ))}
                </Select>
              </Form.Item>
            </div>

            {selectedLoanType === "Housing Loan" && (
              <>
                <div className="col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6">
                  <Form.Item
                    label={t("pages.my_accounts.loans.property_location", {
                      defaultValue: "Property location",
                    })}
                    name={"propertyLocation"}
                    rules={[
                      {
                        required: true,
                        message: t("pages.my_accounts.loans.location_req_txt", {
                          defaultValue: "Location is required",
                        }),
                      },
                    ]}
                  >
                    <Input
                      maxLength={30}
                      placeholder={t("pages.my_accounts.loans.location", {
                        defaultValue: "Location",
                      })}
                      onKeyPress={(e) => allowOnlyAlphaNumericsWithSpace(e)}
                      size="large"
                    />
                  </Form.Item>
                </div>

                <div className="col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6">
                  <Form.Item
                    label={t("pages.my_accounts.loans.property_market_value", {
                      defaultValue: "Property market value",
                    })}
                    name={"propertyMarketValue"}
                    rules={[
                      {
                        required: true,
                        message: t(
                          "pages.my_accounts.loans.property_market_value_req_txt",
                          {
                            defaultValue: "Property Market Value is required",
                          }
                        ),
                      },
                    ]}
                  >
                    <NumericFormat
                      type="tel"
                      maxLength={12}
                      placeholder={t(
                        "pages.my_accounts.loans.property_market_value",
                        {
                          defaultValue: "Property market value",
                        }
                      )}
                      allowNegative={false}
                      customInput={Input}
                      thousandSeparator={true}
                      fixedDecimalScale={false}
                      addonBefore={CONFIG.CURRENCY}
                      onKeyPress={(e) => allowOnlyNumbers(e)}
                      size="large"
                    />
                  </Form.Item>
                </div>
              </>
            )}

            <div className="col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6">
              <Form.Item
                label={t("pages.my_accounts.loans.monthly_income", {
                  defaultValue: "Monthly Income",
                })}
                name={"monthlyIncome"}
                rules={[
                  {
                    required: true,
                    message: t(
                      "pages.my_accounts.loans.monthly_income_req_txt",
                      {
                        defaultValue: "Monthly income is required",
                      }
                    ),
                  },
                ]}
              >
                <NumericFormat
                  type="tel"
                  placeholder={t("pages.my_accounts.loans.monthly_income", {
                    defaultValue: "Monthly Income",
                  })}
                  maxLength={12}
                  allowNegative={false}
                  customInput={Input}
                  thousandSeparator={true}
                  fixedDecimalScale={false}
                  addonBefore={CONFIG.CURRENCY}
                  onKeyPress={(e) => allowOnlyNumbers(e)}
                  size="large"
                />
              </Form.Item>
            </div>

            <div className="col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6">
              <Form.Item
                label={t("pages.my_accounts.loans.annual_income", {
                  defaultValue: "Annual Income",
                })}
                name={"annualIncome"}
                rules={[
                  {
                    required: true,
                    message: t(
                      "pages.my_accounts.loans.annual_income_req_txt",
                      {
                        defaultValue: "Annual income is required",
                      }
                    ),
                  },
                ]}
              >
                <NumericFormat
                  type="tel"
                  placeholder={t("pages.my_accounts.loans.annual_income", {
                    defaultValue: "Annual Income",
                  })}
                  maxLength={12}
                  allowNegative={false}
                  customInput={Input}
                  thousandSeparator={true}
                  fixedDecimalScale={false}
                  addonBefore={CONFIG.CURRENCY}
                  onKeyPress={(e) => allowOnlyNumbers(e)}
                  size="large"
                />
              </Form.Item>
            </div>

            <div className="col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6">
              <Form.Item
                label={t("pages.my_accounts.loans.finance_amount", {
                  defaultValue: "Finance amount",
                })}
                name={"loanAmount"}
                rules={[
                  {
                    required: true,
                    message: t("pages.my_accounts.loans.finance_amount_req", {
                      defaultValue: "Finance amount is required",
                    }),
                  },
                ]}
              >
                <NumericFormat
                  type="tel"
                  placeholder={t("pages.my_accounts.loans.finance_amount", {
                    defaultValue: "Finance amount",
                  })}
                  maxLength={12}
                  allowNegative={false}
                  customInput={Input}
                  thousandSeparator={true}
                  fixedDecimalScale={false}
                  addonBefore={CONFIG.CURRENCY}
                  onKeyPress={(e) => allowOnlyNumbers(e)}
                  size="large"
                />
              </Form.Item>
            </div>

            <div className="col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6">
              <Form.Item
                label={t("pages.my_accounts.loans.roi", {
                  defaultValue: "ROI",
                })}
                name={"interestRate"}
                rules={[
                  {
                    required: false,
                    message: t("pages.my_accounts.loans.roi_req_txt", {
                      defaultValue: "ROI is required",
                    }),
                  },
                ]}
              >
                <NumericFormat
                  type="tel"
                  placeholder={t("pages.my_accounts.loans.roi", {
                    defaultValue: "ROI",
                  })}
                  maxLength={2}
                  allowNegative={false}
                  customInput={Input}
                  thousandSeparator={true}
                  fixedDecimalScale={false}
                  addonAfter={"%"}
                  onKeyPress={(e) => allowOnlyNumbers(e)}
                  size="large"
                />
              </Form.Item>
            </div>

            {["Personal Loan", "Gold Loan"].indexOf(selectedLoanType) >
              -1 && (
              <div className="col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6">
                <Form.Item
                  label={t("pages.my_accounts.deposits.tenure", {
                    defaultValue: "Tenure",
                  })}
                  name={"tenure"}
                  rules={[
                    {
                      required: true,
                      message: t("pages.my_accounts.loans.tenure_req_txt", {
                        defaultValue: "Tenure is required",
                      }),
                    },
                  ]}
                >
                  <Select
                    showSearch
                    optionFilterProp="children"
                    placeholder={t("pages.my_accounts.deposits.tenure", {
                      defaultValue: "Tenure",
                    })}
                    size="large"
                  >
                    {[12, 24, 36].map((option, idx) => (
                      <Select.Option key={idx} value={option}>
                        {option}{" "}
                        {t("pages.accounts.deposits.months", {
                          defaultValue: "Months",
                        })}
                      </Select.Option>
                    ))}
                  </Select>
                </Form.Item>
              </div>
            )}

            {["Personal Loan", "Gold Loan"].indexOf(selectedLoanType) <
              0 && (
              <div className="col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6">
                <Form.Item
                  label={t("pages.my_accounts.deposits.tenure", {
                    defaultValue: "Tenure",
                  })}
                  name={"tenure"}
                  rules={[{ required: true, message: "Tenure is required" }]}
                >
                  <NumericFormat
                    type="tel"
                    placeholder={t("pages.my_accounts.deposits.tenure", {
                      defaultValue: "Tenure",
                    })}
                    maxLength={2}
                    allowNegative={false}
                    customInput={Input}
                    thousandSeparator={true}
                    fixedDecimalScale={false}
                    onKeyPress={(e) => allowOnlyNumbers(e)}
                    size="large"
                  />
                </Form.Item>
              </div>
            )}
          </div>

          <div className="d-flex justify-content-end  mt-3">
            <Button
              onClick={() => setStage(1)}
              size="large"
              type="default"
              className="secondary-btn "
              style={{ marginRight: 20 }}
            >
              {t("buttons.cancel_btn", {
                defaultValue: "Cancel",
              })}
            </Button>
            <Button type="primary" size="large" className="primary-btn" htmlType="submit">
              {t("buttons.next_btn", {
                defaultValue: "Next",
              })}
            </Button>
          </div>
        </Form>
      </>
    );
  }

  function renderConfirm() {
    return (
      <>
        <h5 className="mb-3">
          {t("common.confirmation", {
            defaultValue: "Confirmation",
          })}
        </h5>

        <p className="mb-5" style={{ fontSize: 14 }}>
          {t("pages.my_accounts.loans.please_check_the", {
            defaultValue: "Please check the",
          })}{" "}
          <b>{selectedLoanType}</b>{" "}
          {t("pages.my_accounts.loans.check_txt", {
            defaultValue: "details carefully, before you proceed",
          })}
        </p>
        <div className="confirm-details">
          <div className="row">
            <div className="col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6 mb-3 ">
              <label>
                {t("common.mobile_number", {
                  defaultValue: "Mobile Number",
                })}
              </label>
              <span>{formDetails?.mobileNumber || "-"}</span>
            </div>

            <div className="col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6 mb-3 ">
              <label>
                {t("pages.my_accounts.casa.name", {
                  defaultValue: "Name",
                })}
              </label>
              <span>{formDetails?.name || "-"}</span>
            </div>

            <div className="col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6 mb-3 ">
              <label>
                {t("common.email_id", {
                  defaultValue: "Email Id",
                })}
              </label>
              <span>{formDetails?.emailId || "-"}</span>
            </div>

            <div className="col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6 mb-3 ">
              <label>
                {t("pages.forgotPassword.date_of_birth", {
                  defaultValue: "Date of Birth",
                })}
              </label>
              <span>{dayjs(formDetails?.dob).format("DD-MM-YYYY")}</span>
            </div>

            <div className="col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6 mb-3 ">
              <label>
                {t("pages.my_accounts.loans.state", {
                  defaultValue: "State",
                })}
              </label>
              <span>{formDetails?.state || "-"}</span>
            </div>

            <div className="col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6 mb-3 ">
              <label>
                {t("pages.my_accounts.loans.city", {
                  defaultValue: "City",
                })}
              </label>
              <span>{formDetails?.city || "-"}</span>
            </div>
            {selectedLoanType === "Term Loan" && (
              <div className="col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6 mb-3 ">
                <label>
                  {t("pages.my_accounts.loans.purpose_of_loan", {
                    defaultValue: "Purpose of Finance",
                  })}
                </label>
                <span>{formDetails?.purposeOfLoan || "-"}</span>
              </div>
            )}

            <div className="col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6 mb-3 ">
              <label>
                {t("pages.my_accounts.loans.profession", {
                  defaultValue: "Profession",
                })}
              </label>
              <span>
                {formDetails?.profession === "Other"
                  ? formDetails.sourceofIncome
                  : formDetails.profession}
              </span>
            </div>

            {selectedLoanType === "Gold Loan" && (
              <div className="col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6 mb-3 ">
                <label>
                  {t("pages.my_accounts.loans.gold", {
                    defaultValue: "Qty / Grams of Gold",
                  })}
                </label>
                <span>{formDetails?.qtyGramsGold || "-"}</span>
              </div>
            )}

            {selectedLoanType === "Vehicle Loan" && (
              <div className="col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6 mb-3 ">
                <label>
                  {t("pages.my_accounts.loans.vehicle_type", {
                    defaultValue: "Vehicle Type",
                  })}{" "}
                </label>
                <span>{formDetails?.vehicleRequired || "-"}</span>
              </div>
            )}

            {selectedLoanType === "Housing Loan" && (
              <div className="col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6 mb-3 ">
                <label>
                  {t("pages.my_accounts.loans.property_location", {
                    defaultValue: "Property location",
                  })}{" "}
                </label>
                <span>{formDetails?.propertyLocation || "-"}</span>
              </div>
            )}
            {selectedLoanType === "Housing Loan" && (
              <div className="col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6 mb-3 ">
                <label>
                  {t("pages.my_accounts.loans.property_market_value", {
                    defaultValue: "Property market value",
                  })}{" "}
                </label>
                <span>{formDetails?.propertyMarketValue || "-"}</span>
              </div>
            )}

            {["Education Loan", "Term Loan"].indexOf(selectedLoanType) >
              -1 && (
              <div className="col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6 mb-3 ">
                <label>
                  {t("pages.my_accounts.loans.location", {
                    defaultValue: "Location",
                  })}{" "}
                </label>
                <span>{formDetails?.location || "-"}</span>
              </div>
            )}
            {["Education Loan", "Term Loan"].indexOf(selectedLoanType) >
              -1 && (
              <div className="col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6 mb-3 ">
                <label>
                  {t("pages.my_accounts.loans.collateral", {
                    defaultValue: "Collateral",
                  })}{" "}
                </label>
                <span>{formDetails?.collateralImmovableProperty || "-"}</span>
              </div>
            )}

            {["Education Loan", "Term Loan"].indexOf(selectedLoanType) >
              -1 &&
              collateral === "Yes" && (
                <div className="col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6 mb-3 ">
                  <label>
                    {t("pages.my_accounts.loans.property_value", {
                      defaultValue: "Property Value",
                    })}{" "}
                  </label>
                  <span>{formDetails?.propertyValue || "-"}</span>
                </div>
              )}

            <div className="col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6 mb-3 ">
              <label>
                {t("pages.my_accounts.loans.any_other_credit", {
                  defaultValue: "Any other credit loan",
                })}{" "}
              </label>
              <span>{formDetails?.creditFacilityAvailed || "-"}</span>
            </div>

            <div className="col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6 mb-3 ">
              <label>
                {t("pages.my_accounts.loans.monthly_income", {
                  defaultValue: "Monthly Income",
                })}
              </label>
              <span>{amountFormat(formDetails?.monthlyIncome)}</span>
            </div>

            <div className="col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6 mb-3 ">
              <label>
                {t("pages.my_accounts.loans.annual_income", {
                  defaultValue: "Annual Income",
                })}{" "}
              </label>
              <span>{amountFormat(formDetails?.annualIncome)}</span>
            </div>

            <div className="col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6 mb-3 ">
              <label>
                {t("pages.my_accounts.loans.finance_amount", {
                  defaultValue: "Finance amount",
                })}
              </label>
              <span>{amountFormat(formDetails?.loanAmount)}</span>
            </div>

            <div className="col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6 mb-3 ">
              <label>
                {t("pages.my_accounts.deposits.tenure", {
                  defaultValue: "Tenure",
                })}
              </label>
              <span>
                {formDetails?.tenure || "0"}{" "}
                {t("pages.accounts.deposits.months", {
                  defaultValue: "Months",
                })}{" "}
              </span>
            </div>

            <div className="col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6 mb-3 ">
              <label>
                {t("pages.my_accounts.loans.roi", {
                  defaultValue: "ROI",
                })}{" "}
              </label>
              <span>{formDetails?.interestRate || "0"}%</span>
            </div>
          </div>
        </div>

        <div className="d-flex justify-content-end  mt-3">
          <Button
            onClick={() => setStage(2)}
            size="large"
            type="default"
            style={{ marginRight: 20 }}
          >
            {t("buttons.back_btn", {
              defaultValue: "Back",
            })}
          </Button>
          <Button size="large" type="primary" onClick={() => loanRequestVerify()}>
            {t("buttons.confirm", { defaultValue: "Confirm" })}
          </Button>
        </div>
      </>
    );
  }

  function renderSuccess() {
    return (
      <>
        <img
          style={{ display: "block", margin: "0 auto" }}
          alt="success"
          src={successIcon}
          width={150}
        />
        <div>
          <p
            style={{
              fontSize: 14,
              width: "80%",
              margin: "0 auto",
              textAlign: "center",
            }}
          >
            {message}
          </p>
          <div align="center">
            <Button
              className="mt-3"
              size="large"
              type="default"
              onClick={() => navigate("/accounts", { state: "LA" })}
            >
              {" "}
              {t("buttons.okay_btn", {
                defaultValue: "Okay",
              })}
            </Button>
          </div>
        </div>
      </>
    );
  }

  return (
    <>
    
        <Breadcrumb>
          {/* <Breadcrumb.Item>
            <span onClick={() => navigate("/dashboard")}>
              <HomeIcon height={14}/>
            </span>
          </Breadcrumb.Item> */}
          <Breadcrumb.Item>
            <span onClick={() => navigate("/accounts", { state: "LA" })}>
              {t("navigation.account", {
                defaultValue: "Accounts",
              })}
            </span>
          </Breadcrumb.Item>
          <Breadcrumb.Item>
            <span>
              {t("pages.my_accounts.common_my_accounts.new_facility", {
                defaultValue: "Apply New Loan",
              })}
            </span>
          </Breadcrumb.Item>
        </Breadcrumb>
    
      <Card size="small" className="mb-1 text-center breadcrumb-title-card">
        <div className="row">
          <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 d-flex justify-content-left align-items-center heading mx-0">
            {/* <TitleIcon height={30} style={{ marginLeft: "-20px" }} /> */}
            <h3 className="primary-title">
              {t("pages.my_accounts.common_my_accounts.new_facility", {
                defaultValue: "Apply New Loan",
              })}
            </h3>
          </div>
        </div>
      </Card>
      <div className="row d-flex justify-content-between">
        {stage === 1 || stage === 2 ? (
          <div className="col-xs-12 col-sm-12 col-md-5 col-lg-4 col-xl-4 hide-xs">
            <Card className="application-card" >
              <AccountCard />
            </Card>
          </div>
        ) : (
          <div className="col-xs-12 col-sm-12 col-md-5 col-lg-4 col-xl-4 hide-xs">
            <Card className="application-card" >
              <AccountSelectedCard />
            </Card>
          </div>
        )}

        <div className="col-xs-12 col-sm-12 col-md-12 col-lg-8 col-xl-8">
          {" "}
          <Card className="application-card "> {renderSwitch()}</Card>
        </div>
      </div>{" "}
      <Modal
        title={""}
        open={successVisible}
        footer={null}
        width={480}
        closable={false}
        maskClosable={false}
        mask={true}
      >
        <div style={{ margin: "0 auto" }} align="center">
          <TickIcon height={65} />
          <h4 className="mb-3 mt-2">
            {" "}
            {t("common.success", {
              defaultValue: "Success",
            })}
          </h4>
          <p>{message}</p>

          <div align="center">
            <Button
              size="large"
              style={{ width: 130 }}
              onClick={() => {
                setSuccessVisible(false);
                navigate("/accounts", { state: "LA" });
              }}
              type="primary"
            >
              {t("buttons.okay_btn", {
                defaultValue: "Okay",
              })}
            </Button>
          </div>
        </div>
      </Modal>
    </>
  );
}
